import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import { AppStore } from "../../store"
import OldUIContext from "../../olduicontext"

import { setWorkspaceId } from "../bookmarks/actions"

import * as actions from "./actions"

import CoverPage from "./components/CoverPage"
import { Labels } from "../../util/Translations"
import { IOldUIContext } from "../../global"

interface OldUIInit {
    start: (
        element: HTMLElement | undefined | null,
        workspaceId: number,
        workspaceScreenLabel: string,
    ) => void
}

function init(store: AppStore, oldUIContext: IOldUIContext): OldUIInit {
    const start = (
        element: HTMLElement | undefined | null,
        workspaceId: number,
        workspaceScreenLabel: string,
    ): void => {
        if (!element) {
            throw new Error("Element should have value")
        }

        const {
            Content,
            NoWorkspaceContentFound,
            NoWorkspaceContentFoundFiltered,
        } = Labels

        store.dispatch(setWorkspaceId(workspaceId))
        store.dispatch(
            actions.initialize(
                workspaceId,
                workspaceScreenLabel,
                NoWorkspaceContentFound,
                NoWorkspaceContentFoundFiltered,
                Content,
            ),
        )

        const root = createRoot(element)
        root.render(
            <Provider store={store}>
                <OldUIContext.Provider value={oldUIContext}>
                    <CoverPage />
                </OldUIContext.Provider>
            </Provider>,
        )
    }

    return {
        start,
    }
}

export default init
